import React from 'react';

import { MainView, NoAccessView } from '@repo/ui/Views';
import CampaignsTable from '@/features/tcr/components/CampaignsTable';

import { POLICIES } from '@/lib/Authorization';
import { useUser } from '@repo/hooks/useUser';
import { useAccount } from '@/hooks/useAccount';

const Campaigns = () => {
  const user = useUser();
  const account = useAccount();
  const accountId = account.id;

  return POLICIES['csp_campaigns:index'](user) ? (
    <MainView title="TCR Campaigns">
      <CampaignsTable accountId={Array.isArray(accountId) ? accountId[0] : accountId} />
    </MainView>
  ) : (
    <NoAccessView />
  );
};

export default Campaigns;
